import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '@/views/login/index'
import Layout from '@/layout/index.vue'
import Pdfen from '@/views/pdfen/index'
import Pdf from '@/views/pdf/index'
let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
let url = ["cnrs.ams-dev.mvgx.com", "cnrs.test.mvgx.com", "www.cnrs.mvgx.com"]
let name = location.hostname
let RoleName = null
if (userInfo) {
    RoleName = userInfo.roleCode ? userInfo.roleCode : null
}
const routes = [
    { path: '/login', component: Login, name: 'login', hidden: true },
    { path: '/pdf', component: Pdf, name: 'pdf', hidden: true },
    { path: '/pdfen', component: Pdfen, name: 'pdfen', hidden: true },
    {
        path: '/',
        name: 'Index',
        redirect: '/',
        meta: {
            title: '首页',
            icon: 'home-4-line',
            roles: ['ROLE_TUV_ADMIN'],
            type: 1, //判断是否是首页
            isRouteBool: false, //判断是否展示多个菜单
        },
        // hidden: false,
        hidden: RoleName !== 'ROLE_TUV_ADMIN',
        alwaysShow: false,
        component: Layout,
        children: [{
            path: '/',
            name: 'Home',
            component: () =>
                import ("@/views/home/index.vue"),
            meta: {
                title: '',
                icon: '',
                roles: ['ROLE_TUV_ADMIN'],
                affix: true,
            },
            hidden: true,
        },
        {
            path: '/homeList',
            name: 'List',
            component: () =>
                import ("@/views/home/list.vue"),
            meta: {
                title: '企业评级列表',
                icon: '',
                roles: ['ROLE_TUV_ADMIN'],
                affix: true,
            },
            hidden: true,
        }, ]
    },

    {
        path: '/enterprise',
        name: 'enterprise',
        redirect: '/enterprise',
        meta: {
            title: '企业管理',
            icon: 'building-line',
            roles: ['ROLE_TUV_ADMIN'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        // hidden: false,
        hidden: RoleName !== 'ROLE_TUV_ADMIN' || url.includes(name),
        component: Layout,
        children: [{
                path: '/enterprise',
                name: 'enterpriseList',
                component: () =>
                    import ("@/views/enterprise/index.vue"),
                meta: {
                    title: '企业管理列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/enterprise/detail',
                name: 'enterpriseDetail',
                component: () =>
                    import ("@/views/enterprise/detail.vue"),
                meta: {
                    title: '企业详情',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
        ]
    },

    {
        path: '/scoring',
        name: 'scoring',
        redirect: '/scoring',
        meta: {
            title: '评分审核',
            icon: 'clipboard-line',
            roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        hidden: false,
        component: Layout,
        children: [{
                path: '/scoring',
                name: 'scoringList',
                component: () =>
                    import ("@/views/scoringReview/index.vue"),
                meta: {
                    title: '评分审核列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                    affix: true,
                    type: 1,
                },
                hidden: true,
            },
            {
                path: '/scoring/detail',
                name: 'scoringDetail',
                component: () =>
                    import ("@/views/scoringReview/detail.vue"),
                meta: {
                    title: '问卷审核',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                },
                hidden: true,
            },
            {
                path: '/scoring/report',
                name: 'scoringReport',
                component: () =>
                    import ("@/views/scoringReview/report.vue"),
                meta: {
                    title: '报告审核',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                },
                hidden: true,
            },
        ]
    },


    {
        path: '/stand/list',
        name: 'stand',
        redirect: '/stand/list',
        meta: {
            title: '问题反馈',
            icon: 'message-2-line',
            roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
            isRouteBool: true, //判断是否展示多个菜单
        },
        hidden: false,
        component: Layout,
        alwaysShow: true,
        children: [
            // {
            //     path: '/stand/list',
            //     name: 'standList',
            //     component: () =>
            //         import ("@/views/Message/contactus/index.vue"),
            //     meta: {
            //         title: '联系我们',
            //         icon: '',
            //         roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
            //         affix: true,
            //         type: 1,
            //     },
            //     hidden: url.includes(name),
            // },
            {
                path: '/stand/list',
                name: 'standEmissionfactor',
                component: () =>
                    import ("@/views/Message/problem/index.vue"),
                meta: {
                    title: '问题反馈列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN', 'ROLE_TUV_ENGINEER'],
                    affix: true,
                    type: 1,
                },
                hidden: true,
            },
        ]
    },

    // {
    //     path: '/personal',
    //     name: 'personal',
    //     redirect: '/personal',
    //     meta: {
    //         title: '角色权限',
    //         icon: 'user-settings-line',
    //         roles: ['admin'],
    //         isRouteBool: false, //判断是否展示多个菜单
    //     },
    //     // hidden: true,
    //     hidden: RoleName == 'ROLE_TUV_ADMIN',
    //     component: Layout,
    //     children: [{
    //         path: '/personal',
    //         name: 'personalList',
    //         component: () =>
    //             import ("@/views/personalCenter/personalinfo.vue"),
    //         meta: {
    //             title: '',
    //             icon: '',
    //             roles: ['admin'],
    //             affix: true,
    //         },
    //         hidden: true,
    //     }, ]
    // },


    {
        path: '/account',
        name: 'account',
        redirect: '/account',
        meta: {
            title: '账号管理',
            icon: 'share-line',
            roles: ['ROLE_TUV_ADMIN'],
            isRouteBool: false, //判断是否展示多个菜单
        },
        // hidden: false,
        hidden: RoleName !== 'ROLE_TUV_ADMIN',
        alwaysShow: true,
        component: Layout,
        children: [{
                path: '/account',
                name: 'accountList',
                component: () =>
                    import ("@/views/account/index.vue"),
                meta: {
                    title: '账号管理列表',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/account/detail',
                name: 'accountDetail',
                component: () =>
                    import ("@/views/account/detail.vue"),
                meta: {
                    title: '账号信息',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
            {
                path: '/account/transfer',
                name: 'accountTransfer',
                component: () =>
                    import ("@/views/account/transfer.vue"),
                meta: {
                    title: '权限转移',
                    icon: '',
                    roles: ['ROLE_TUV_ADMIN'],
                    affix: true,
                },
                hidden: true,
            },
        ]
    },



]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router

//路由拦截
router.beforeEach((to, from, next) => {
    //如果访问的是登录页面，直接放行
    if (to.path === '/login') {
        return next()
    }
    //如果访问的是有登陆权限的页面，先要获取登录信息
    const token = window.sessionStorage.getItem('token')
        //如果登录信息不存在，强制跳转登录页面，否则放行
    if (!token) {
        return next('/login')
    }
    next()
})
router.afterEach(((to, from) => {
    if (from.path == '/login') {
        window.location.reload();
    }
}))